import appLogger from "../../infra/logger/appLogger";
import { getAnalyticsProvider } from "./analytics";
const analyticsLogger = appLogger.withTag("Analytics");
const logEvent = (eventName, eventData) => {
    try {
        const analytics = getAnalyticsProvider();
        if (!analytics) {
            return;
        }
        analytics.logEvent(eventName, eventData);
    }
    catch (error) {
        analyticsLogger.error(error);
    }
};
// Module-level so consumers can list it as a dependency without re-creating their callbacks.
const useAnalytics = () => ({ logEvent });
export default useAnalytics;
